// Small public-page behaviour, loaded alongside the existing pack listeners.
const initPhraseLevels = () => {
  document.querySelectorAll("[data-phrase-levels]").forEach((root) => {
    if (root.dataset.initialized) return;
    const chips = [...root.querySelectorAll("[data-phrase-level]")];
    const bands = [...root.querySelectorAll("[data-phrase-band]")];
    if (!chips.length) return;
    root.dataset.initialized = "true";
    const storageKey = "learn.phrases.level";
    const apply = (level) => {
      bands.forEach((band) => {
        band.hidden = level !== "all" && band.dataset.phraseBand !== level;
      });
      chips.forEach((chip) => {
        if (chip.dataset.phraseLevel === level)
          chip.setAttribute("aria-current", "true");
        else chip.removeAttribute("aria-current");
      });
    };
    chips.forEach((chip) => {
      chip.addEventListener("click", () => {
        const level = chip.dataset.phraseLevel;
        apply(level);
        try {
          if (level === "all") localStorage.removeItem(storageKey);
          else localStorage.setItem(storageKey, level);
        } catch (_) {
          /* Filtering still works when storage is unavailable. */
        }
      });
    });
    try {
      const saved = localStorage.getItem(storageKey);
      if (bands.some((band) => band.dataset.phraseBand === saved)) apply(saved);
    } catch (_) {
      /* Show every band when storage is unavailable. */
    }
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPhraseLevels);
} else {
  initPhraseLevels();
}
document.addEventListener("turbo:load", initPhraseLevels);

import "./phrase_practice";
